export default {"src":"/_next/static/media/404.acd334e0.svg","height":515,"width":532,"blurWidth":0,"blurHeight":0};